var React = require('react');

function YourEveryDay (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.25 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9.25 3zm-7 5A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v3.5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h7.486a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 18V8zM23 17.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zm-4.5-2.75a.75.75 0 0 1 .75.75v1.69l1.28 1.28a.75.75 0 1 1-1.06 1.06l-1.5-1.5-.22-.22V15.5a.75.75 0 0 1 .75-.75z","fill":"#fff"}));
}

YourEveryDay.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = YourEveryDay;

YourEveryDay.default = YourEveryDay;
